
import {
  Badge,
  Box,
  Button,
  Flex,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { Notification } from 'api/notificationRepository';

interface NotificationDetailCardProps {
  notification?: Notification;
  onDelete?: () => void;
}

const NotificationDetailCard: React.FC<NotificationDetailCardProps> = ({
  notification,
  onDelete,
}) => {
  const infoBg = useColorModeValue('white', 'navy.700');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.800', 'white');

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      p={6}
      bg={infoBg}
      borderColor={borderColor}
      shadow="sm"
      mb={8}
    >
      {/* Header */}
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="2xl" fontWeight="bold" color={textColor}>
          Notification Detail
        </Text>

        {onDelete && (
          <Button colorScheme="red" variant="solid" onClick={onDelete}>
            Delete
          </Button>
        )}
      </Flex>

      {/* Details */}
      <Flex direction="column" gap={5}>
        <Text color={textColor}>
          <strong>Recipient:</strong>{' '}
          {notification?.recipient || '-'}
        </Text>

        {/* Email Preview */}
        <Box>
          <Text fontWeight="bold" color={textColor} mb={2}>
            Message:
          </Text>

          <Box
            borderWidth="1px"
            borderColor={borderColor}
            borderRadius="md"
            overflow="hidden"
            bg="white"
          >
            <iframe
              title="Email Preview"
              srcDoc={notification?.message || ''}
              style={{
                width: '100%',
                minHeight: '600px',
                border: 'none',
                background: 'white',
              }}
            />
          </Box>
        </Box>

        <Text color={textColor}>
          <strong>Vendor Name:</strong>{' '}
          {notification?.vendorName || '-'}
        </Text>

        <Text color={textColor}>
          <strong>Asset Name:</strong>{' '}
          {notification?.assetName || '-'}
        </Text>

        <Text color={textColor}>
          <strong>Organization Name:</strong>{' '}
          {notification?.organizationName || '-'}
        </Text>

        <Text color={textColor}>
          <strong>Reminder Count:</strong>{' '}
          {notification?.reminderCount ?? 0}
        </Text>

        <Flex align="center" gap={2}>
          <Text color={textColor} fontWeight="bold">
            Status:
          </Text>

          <Badge
            colorScheme={notification?.delivered ? 'green' : 'red'}
            variant="solid"
            px={3}
            py={1}
            borderRadius="full"
          >
            {notification?.delivered ? 'Delivered' : 'Pending'}
          </Badge>
        </Flex>
      </Flex>
    </Box>
  );
};

export default NotificationDetailCard;